/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './uploadVideo.defs.js'
export * as $defs from './uploadVideo.defs.js'
